import Image from 'common/components/Image';
import { StyledFlex } from 'common/styles/common.styles';
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import React, { PropsWithChildren } from 'react';
import { StyledMetricsButton } from './linkButton.style';
import useSelectedChain from 'hooks/useSelectedChain';
import Tooltip from '../Tooltip/Tooltip';

type Props = {
  address: string;
  className?: string;
};

export const MetricsButton: React.FC<Props & PropsWithChildren> = (
  props
) => {
  const { chainId } = useSelectedChain();

  const btnHeight = props.className?.includes(' h-') ? '' : 'h-8';
  return (
    <div className='w-8 tablet:w-8'>
      <Tooltip
        message='Click to View Vault Metrics'
        position='left'
        bubbleSize={{ width: '200px', }}
      >
        <StyledMetricsButton>
          <OutboundLink target="_blank" 
            href={`https://vaultmetrics.io/?vault_address=${props.address}&chain_id=${chainId}`}>
            <button
              className={`${btnHeight}`}
              type="button"
            >
              <StyledFlex justifyContent="center">
                <Image src='https://ichi-images.s3.amazonaws.com/misc/icon-chart.png' height='32px' alt='View Vault Metrics' />
              </StyledFlex>
            </button>
          </OutboundLink>
        </StyledMetricsButton>
      </Tooltip>
    </div>
  );
};
